'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { atom, useAtomValue, useSetAtom } from 'jotai';

// Dropdown max height constants for single and multi row.
export const DROPDOWN_MAX_HEIGHT_SINGLE_ROW = 464;
export const DROPDOWN_MAX_HEIGHT_MULTI_ROW = 408;
export const DROPDOWN_BOTTOM_MARGIN = 16; // Space from bottom of viewport
export const DROPDOWN_MIN_HEIGHT = 260; // Minimum dropdown height

const WRAP_BREAKPOINT = 1400;
const isWrappedAtom = atom(false);
export const useIsWrapped = () => {
  return useAtomValue(isWrappedAtom);
};
export const FilterListMediaQuerySync = () => {
  const $ = _c(3);
  const setIsWrapped = useSetAtom(isWrappedAtom);
  let t0;
  let t1;
  if ($[0] !== setIsWrapped) {
    t0 = () => {
      const mediaQuery = window.matchMedia(`(max-width: ${WRAP_BREAKPOINT}px)`);
      setIsWrapped(mediaQuery.matches);
      const handleChange = e => {
        setIsWrapped(e.matches);
      };
      mediaQuery.addEventListener("change", handleChange);
      return () => mediaQuery.removeEventListener("change", handleChange);
    };
    t1 = [setIsWrapped];
    $[0] = setIsWrapped;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
};